<template>
  <main>
    <h1>FAQ</h1>
    <p>This is the FAQ page</p>
    <section class="questions">
      <article class="q-card">
        <h4>How is the product delivered?</h4>

        <p>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          One of our staff will be dispatched to deliver the game to your door,
          or designated meetup point. If purchasing the game outright, then it
          will be shipped to your address, with potential of paying a premium
          fee for immediate delivery.
        </p>
        <p>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          All orders are normally sent via Canada Post. We can also ship through
          FedEx or Purolator at additional cost if specifically requested.
        </p>
        <p>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          We take the utmost care in packing orders. Books and magazines are
          normally bagged, and adequate packing material is always used. We can
          overpack or double-box on request, but please note that this may raise
          the shipping cost if the volume of the package is significantly
          increased.
        </p>
        <p>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          Please note that Canada Post does not provide weekend service, thus
          all delivery estimates should be read as Business Days.
        </p>
      </article>

      <article class="q-card">
        <h4>When will I receive my game by?</h4>
        <p>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          Shipping times reflect delivery standards for urban centres. Please
          add an additional 1-2 days for rural addresses. Please note that
          additional charges may apply for oversized items (eg. carrying cases,
          gaming mats) or especially remote addresses. Shipments within Canada
          will be charged 5% GST (Alberta has no provincial sales tax).
        </p>
      </article>

      <article class="q-card">
        <h4>What do I to return my game?</h4>
        <p>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          You can either return the game in person, or drop it off at one of the
          designated pick-up points listed on the site directory. Our staff make
          routine trips to these checkpoints.
        </p>
        <p>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          Please ensure that all of the pieces and instructions are returned
          with the original packaging, and in good condition, or additional
          charges will be incurred.
        </p>
      </article>

      <article class="q-card">
        <h4>How does payment work?</h4>
        <p>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          Payment is accepted through a secure and embedded service known as
          Stripe (facilitates payments for Shopify, Amazon, Spotify and many
          more).We accept all major credit cards supported by this platform. For
          international orders, charges will be billed in Canadian dollars.
          Stripe will handle all conversions!
        </p>
      </article>
    </section>
  </main>
</template>

<script>
export default {
	name: 'FAQ',
};
</script>

<style>
main {
}

.questions {
  margin: 1rem auto;
  background-color: antiquewhite;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  min-width: 500px;
  width: 80vw;
  padding: 20px 20px;
}

.q-card {
  margin: 0.5rem 0;
  padding: 4px;
  border-radius: 4px;

  background-color: #fff;

  text-align: left;

  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.q-card > h4 {
  display: flex;
  flex-wrap: wrap;

  padding: 1rem;

  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125rem;
  line-height: 2rem;
  word-break: break-all;

  border-bottom: 1px solid rgba(0, 0, 0, 0.6);

  color: var(--abbadon-black);
}

.q-card > p {
  display: block;

  padding: 0 1rem 1rem 1rem;
  width: 100%;

  font-size: 0.875rem;
  letter-spacing: 0.1;
  line-height: 1.375rem;

  color: rgba(0, 0, 0, 0.6);
}

/* .questions p {
	color: rgb(37, 41, 34);
	margin-left: 1em;
	font-size: 1.2em;
	text-align: start;
} */
@media screen and (max-width: 800px) {
  .questions {
    font-size: 0.8em;
    padding: 10px 10px;
    width: 478px;
  }
  @media screen and (max-width: 500px) {
    .questions {
      font-size: 0.8em;
      padding: 20px 20px;
      width: 400px;
    }
  }
}
</style>
